module.exports = __webpack_public_path__ + "img/CustomerService.96720aff.svg";